import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeviceState {
  uuid: string | null;
}

const initialState: DeviceState = {
  uuid: null,
};

export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDeviceUUID: (state, action: PayloadAction<string>) => {
      state.uuid = action.payload;
    },
  },
});

export const { setDeviceUUID } = deviceSlice.actions;
export default deviceSlice;